/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import {useStaticQuery, graphql, Script, Link} from "gatsby"
import Secondary from "./Menu/secondary";
import {generateUrlForStaticPages} from "../services/intl.service";
import {map} from "react-bootstrap/ElementChildren";
import parse from "html-react-parser";

function Seo({ data, pageContext }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
        imageSharp(
          fluid: { originalName: { eq: "logo-heritage-resorts.png" } }
        ) {
          fluid {
            src
          }
        }
      }
    `
  )

  const defaultTitle = site.siteMetadata?.title
  //const metaDescription = site.siteMetadata?.description
  const logo = site.imageSharp?.fluid?.src
  const image =
    data.ogTags?.image !== "image"
      ? data.ogTags?.image
      : process.env.GATSBY_URL + logo
  const metaTags = []

  // if og:description is not set, use meta description
  if (!data.ogTags.description) {
    data.ogTags.description = data.meta.description
  }

  // Add meta tags
  for (let key in data.meta) {
    const value = data.meta[key]

    if (value) {
      metaTags.push({
        name: key,
        content: value,
      })
    }
  }

  // Add OG tags
  for (let key in data.ogTags) {
    const value = data.ogTags[key]

    if (value) {
      metaTags.push({
        property: "og:" + key,
        content: value,
      })
    }
  }

  // Get links for pages
  const AllURL = (pageContext?.translatedUrls !== undefined ? pageContext.translatedUrls : `{"fr":"/","en":"/en/"}`)
  const getAllUrls = JSON.parse(AllURL)
  const frLink = getAllUrls?.fr
  const enLink = getAllUrls?.en
  const siteURL = `${process.env.GATSBY_URL}`
  const Url = siteURL.slice(0, -1)

  return (
    <>
      <Helmet
        htmlAttributes={{ lang: data.lang }}
        //bodyAttributes={{ title: data.title }}
        title={data.title}
        //titleTemplate={defaultTitle ? `%s | ${defaultTitle}` : null}
        meta={metaTags}
      >
        <Script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "Organization",
              "url": "${process.env.GATSBY_URL}",
              "name": "${defaultTitle}",
              "logo": "${process.env.GATSBY_URL + logo}",
              "image": "${image}",
              "sameAs": [
                "https://www.facebook.com/HeritageResortsMauritius",
                "https://www.instagram.com/heritageresorts/"
              ],
              "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+230 260 5101",
                "contactType": "Customer Support"
              }
            }
          `}
        </Script>

        <link rel="alternate" hrefLang="x-default" href={Url + frLink} />
        <link rel="alternate" hrefLang="fr" href={Url + frLink} />
        <link rel="alternate" hrefLang="en" href={Url + enLink} />

      </Helmet>
      {/* {data.pageTitle && (
        <h1 className="element-invisible">{data.pageTitle}</h1>
      )} */}
    </>
  )
}

Seo.propTypes = {
  lang: PropTypes.string,
  meta: PropTypes.shape({
    description: PropTypes.string,
  }),
  ogTags: PropTypes.shape({
    description: PropTypes.string,
    image: PropTypes.string,
    locale: PropTypes.string,
    title: PropTypes.string,
    type: PropTypes.string,
    url: PropTypes.string,
  }),
  title: PropTypes.string,
}

export default Seo
